import { SKILLS_ASSESSMENT_BASE_PATH, SKILLS_ASSESSMENT_PATH } from "../SkillsAssessment/paths";

export const CLIPBOARD_ORIENTATION_RESCHEDULED_BASE_PATH = `${SKILLS_ASSESSMENT_BASE_PATH}/rescheduled`;
export const CLIPBOARD_ORIENTATION_RESCHEDULED_PATH = `${SKILLS_ASSESSMENT_PATH}/rescheduled`;
